import { createTheme } from "@mui/material";
import { breakpoints } from "./breakpoints";

export const theme = createTheme({
  breakpoints,
  typography: { fontFamily: "Poppins" },
  palette: {
    primary: {
      main: "#7355FB",
      light: "#c7bbfd",
      extraLight: "#F1EEFF",
      dark: "#302D84",
    },
    secondary: {
      main: "#9c27b0",
      dark: "#25257F",
    },
    text: {
      primaryLight: "#c7bbfd",
      primaryExtraLight: "#F1EEFF",
      primaryDark: "#302D84",
      secondaryDark: "#211F5C",
      black: "#414046",
      lightBlack: "#414046",
      gray: "#757475",
      lightGray: "#C5C5C5",
      success: "#00A650",
      disabled: "#0000001F",
      link: "#1b72e8",
    },
    background: {
      default: "#F9F9F9",
      primary: "#F5F8FB",
      secondary: "#E5EDF6",
      gray: "#757475",
      lightGray: "#f9f9f9",
      lightGreen: "rgba(67, 160, 71, 0.1)",
      lightRed: "rgba(226, 35, 26, 0.1)",
      white: "#FFFFFF",
      transparentWhite: "rgba(255, 255, 255, 0.8)",
    },
    success: {
      main: "#4CAF50",
    },
    error: {
      main: "#D32F2F",
    },
    info: {
      main: "#2196F3",
      light: "#E2EFF8",
      contrastText: "#0D3C61",
    },
    documentTypes: {
      PRESCRIPTION: "#41BBF0",
      COMPOUNDED_PRESCRIPTION: "#7BECFE",
      MEDICAL_CERTIFICATE: "#7355FB",
      MEDICAL_ORDER: "#25257F",
    },
  },
});
